import styled from '@emotion/styled';

import ShareButton from './share/ShareButton';

import COLOR from '../../../../../shared/constant/colorset';
import { DeliveryInfo } from '../../../types';

const Container = styled.div``;

const DeliveryTypeName = styled.div`
  font-weight: 500;
  line-height: 1.36;
  letter-spacing: -0.5px;
  color: ${COLOR.kurlyGray450};
  margin-bottom: 6px;
  width: 500px;
`;

const ProductNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
`;

const Title = styled.h2`
  width: 500px;
  font-weight: 500;
  font-size: 24px;
  color: ${COLOR.kurlyGray800};
  line-height: 34px;
  letter-spacing: -0.5px;
  word-break: keep-all;
  margin-right: 20px;
`;

const ShortDescription = styled.p`
  padding-top: 5px;
  font-size: 14px;
  color: ${COLOR.kurlyGray400};
  line-height: 19px;
  letter-spacing: -0.5px;
`;

interface Props {
  productNo: number;
  deliveryInfo: DeliveryInfo;
  name: string;
  shortDescription: string;
}

export default function Name({
  productNo,
  deliveryInfo,
  name,
  shortDescription,
}: Props) {
  const { deliveryName } = deliveryInfo;

  return (
    <Container>
      <DeliveryTypeName>{deliveryName}</DeliveryTypeName>
      <ProductNameWrapper>
        <TitleWrapper>
          <Title>{name}</Title>
          <ShareButton productNo={productNo} />
        </TitleWrapper>
        <ShortDescription>{shortDescription}</ShortDescription>
      </ProductNameWrapper>
    </Container>
  );
}
